import { render, staticRenderFns } from "./exchange-rate-download.pug?vue&type=template&id=0ca70490&lang=pug&external"
import script from "./exchange-rate-download.js?vue&type=script&lang=js&external"
export * from "./exchange-rate-download.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports